import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbDateParserFormatter, NgbDateStruct, NgbInputDatepickerConfig } from '@ng-bootstrap/ng-bootstrap';
import { RootScopeDeclare } from '../rootscope-declare';
import { RootScopeService } from '../shared-service/root-scope.service';
import { NgbDateCustomParserFormatter } from './ngb-date-parser-formatter';
@Component({
  selector: 'app-date-range-picker',
  templateUrl: './date-range-picker.component.html',
  styleUrls: ['./date-range-picker.component.scss'],
  providers: [
    {provide: NgbDateParserFormatter, useClass: NgbDateCustomParserFormatter}
   ]

})
export class DateRangePickerComponent implements OnInit {
  form: FormGroup;
  defaultDate: NgbDateStruct;
  defaultDateTo: NgbDateStruct;
  model: NgbDateStruct;
  modelTo: NgbDateStruct;
  dpConfig: NgbInputDatepickerConfig;
  ddConfig: NgbInputDatepickerConfig;
  rootScopeData: RootScopeDeclare;
  config: NgbInputDatepickerConfig
  @Input() editDateVisible: boolean;
  @Input() dateFrom: Date;
  @Input() dateTo: Date;
  @Output() dateRangeChange = new EventEmitter<any>();
  constructor(private fb: FormBuilder, config: NgbInputDatepickerConfig, private rootScopeService: RootScopeService,) {
   this.config = config;
   }

  ngOnInit(): void {
    const max = new Date();
    this.config.minDate = { year: this.dateFrom.getFullYear(), month: this.dateFrom.getMonth() + 1, day: this.dateFrom.getDate() };
    this.config.maxDate = { year: max.getFullYear(), month: max.getMonth() + 1, day: max.getDate() };
    this.defaultDate = { year: this.dateFrom.getFullYear(), month: this.dateFrom.getMonth() + 1, day: this.dateFrom.getDate() };
    this.config.showWeekdays = true;
    this.config.container = 'body';
    this.config.navigation = "arrows";
    this.dpConfig = this.config;
    this.model = this.defaultDate;
    this.defaultDateTo = { year: this.dateTo.getFullYear(), month: this.dateTo.getMonth() + 1, day: this.dateTo.getDate() };
    this.ddConfig = Object.assign({}, this.config)
    this.modelTo = this.defaultDateTo;

    this.form = this.fb.group(
      {
        dateFrom: ['', Validators.required],
        dateTo: ['', Validators.required],
      },
      {
        validator: [this.validateTime()],
      }
    );
  }

  getRootScopeData(): void {
    this.rootScopeService.getRootScope().subscribe((rootScopeData) => {
      this.rootScopeData = rootScopeData;
      if (rootScopeData.deviceType=="phone" || rootScopeData.deviceType=="tablet") {
        this.dpConfig.autoClose = false;
        this.ddConfig.autoClose = false;
      }
    });
  }

  validateTime() {
    return (formGroup: FormGroup) => {
        const dateFrom = formGroup.controls['dateFrom'];
        const dateTo = formGroup.controls['dateTo'];
        let error = false;
        let from = dateFrom.value;
        let to = dateTo.value;
        if(from.year > to.year) {
          error = true;
        } else if((from.year === to.year) && (from.month > to.month)) {
          error = true;
        } else if((from.year === to.year) && (from.month === to.month) && (from.day > to.day)) {
          error = true;
        }
        if (error) {
          dateFrom.setErrors({ invalid: true });
          dateTo.setErrors({ invalid: true });
        } else {
          dateFrom.setErrors(null);
          dateTo.setErrors(null);
        }
    };
  }

  close() {
    if(this.form.status === "VALID") {
      this.editDateVisible = false;
      this.dateFrom = this.form.value.dateFrom;
      this.dateTo = this.form.value.dateTo;
      this.dateRangeChange.emit({visible: this.editDateVisible, dateFrom: this.form.value.dateFrom, dateTo: this.form.value.dateTo}); 
    }
 }
  
  closeDialog() {
    this.editDateVisible = false;
    this.dateRangeChange.emit({visible: this.editDateVisible, dateFrom: null, dateTo: null});
  }

  ngOnDestroy() {
  }
}
